/** Beliefnet global REST API (Umbraco-backed); same host/version pattern as contact-us global forms. */
export const BELIEFNET_GLOBAL_API_V2_BASE = 'https://api.beliefnet.com/global/api/v2';

export const BELIEFNET_NEWSLETTERS_SITE_SEGMENT = 'beliefnet';

/** Base path for `NewslettersController`: `.../newsletters/beliefnet` */
export const BELIEFNET_NEWSLETTERS_API_BASE = `${BELIEFNET_GLOBAL_API_V2_BASE}/newsletters/${BELIEFNET_NEWSLETTERS_SITE_SEGMENT}`;

export const BELIEFNET_ASSETS_BASE = 'https://assets.beliefnet.com';

export function beliefnetNewsletterSubscriptionsUrl(email: string): string {
    return `${BELIEFNET_NEWSLETTERS_API_BASE}/${encodeURIComponent(email)}/subscriptions`;
}

export function beliefnetNewsletterSubscriptionItemUrl(email: string, newsletterKeyOrCampaignId: string): string {
    return `${BELIEFNET_NEWSLETTERS_API_BASE}/${encodeURIComponent(email)}/subscriptions/${encodeURIComponent(newsletterKeyOrCampaignId)}`;
}
